import classNames from 'classnames/bind';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import SunCalc from 'suncalc';

import styles from './SunTimes.module.scss';
import Term from './Term';

import Bar from '@/components/ui/Bar';
import dayjs from '@/libs/dayjs';

const cx = classNames.bind(styles);

const SunTimes = () => {
  const position = useSelector((state) => state.map.position);

  const sunTimes = useMemo(() => {
    const { sunrise, sunset } = SunCalc.getTimes(new Date(), position.lat, position.lng);

    return {
      sunrise: dayjs(sunrise).format('HH:mm'),
      sunset: dayjs(sunset).format('HH:mm'),
    };
  }, [position]);

  return (
    <div className={cx('container')} data-hide-priority={3}>
      <Term label="Sunrise" value={sunTimes.sunrise} />
      <Bar size={28} />
      <Term label="Sunset" value={sunTimes.sunset} />
      <Bar size={28} />
    </div>
  );
};

export default SunTimes;
